export default "__VITE_ASSET__C7MfQ87N__"